<template>
  <div id="kml">
    <input
      id="pac-input"
      class="controls pb-2 pt-3"
      type="text"
      placeholder="Pesquisar"
    />
    <div id="map">map</div>
    <div id="capture"></div>
    <div id="encoded-polyline"></div>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: "AIzaSyArHrhQ9s4JTAYq2Y0LDhc804z0TJ_MWJU",
  version: "weekly",
  libraries: ["places", "geometry"]
});

const mapOptions = {
  center: {
    lat: -15.79439234188773,
    lng: -47.876955199028764
  },
  zoom: 5,
  mapTypeId: "hybrid",
  scaleControl: true
};

export default {
  namespaced: true,
  data: () => ({
    map: null, // armazena o mapa gerado pela api
    google: null, // a api google maps propriamente dito
    poly: null, // armazena a area demarcada
    infoWindow: null, // armazena o texto com o tamanho da área
    coordinates: [], // contem os pontos demarcados do mapa
    areaSizeInMeters: 0, // tamanho da area marcada em metros
    input: null // contem o controle de barra de pesquisa
  }),
  created() {
    this.coordinates = this.formatCoordinatesToLatLngLiteral(this.coordenadas);
    this.initializeGoogleMaps();
  },
  methods: {
    getAreaSizeInHa() {
      if (this.areaSizeInMeters == 0) {
        this.calculatePolygonAreaSize();
      }
      let areaInHa = this.areaSizeInMeters / 10000;
      return areaInHa.toFixed(2);
    },
    getAreaSizeInMeters() {
      if (this.areaSizeInMeters == 0) {
        this.calculatePolygonAreaSize();
      }
      return this.areaSizeInMeters;
    },
    getCoordinates() {
      let result = [];

      if (this.coordinates.getLength) {
        for (let i = 0; i < this.coordinates.getLength(); i++) {
          const coord = this.coordinates.getAt(i);
          result.push({
            latitude: coord.lat(),
            longitude: coord.lng()
          });
        }
      }

      return result;
    },
    initializeGoogleMaps() {
      this.map = null;
      this.google = null;
      this.kmlLayer = null;
      this.poly = null;
      this.infoWindow = null;
      this.areaSizeInMeters = 0;

      this.google = loader
        .load()
        .then(google => {
          this.google = google;
          this.map = new google.maps.Map(
            document.getElementById("map"),
            mapOptions
          );
          this.addPolygon().then(() => {
            this.initializePathEvents();
            this.calculatePolygonAreaSize();
          });
          this.initializeSearchBox();
        })
        .catch(e => {
          console.log("erro: ", e);
        });
    },
    initializePathEvents() {
      this.google.maps.event.addListener(
        this.poly.getPath() ?? [],
        "set_at",
        () => {
          this.calculatePolygonAreaSize();
        }
      );
      this.google.maps.event.addListener(
        this.poly.getPath() ?? [],
        "insert_at",
        () => {
          this.calculatePolygonAreaSize();
        }
      );
    },
    initializeSearchBox() {
      if (!this.input) {
        this.input = document.getElementById("pac-input");
      }
      // Create the search box and link it to the UI element.
      let searchBox = new this.google.maps.places.SearchBox(this.input);
      this.map.controls[this.google.maps.ControlPosition.TOP_LEFT].push(this.input);
      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener("bounds_changed", () => {
        searchBox.setBounds(this.map.getBounds());
      });

      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();
        if (places.length == 0) { return; }

        var bounds = new this.google.maps.LatLngBounds();
        bounds.extend(places[0].geometry.location);
        this.map.setCenter(bounds.getCenter());
        this.map.fitBounds(bounds);
      });
    },
    setInfoWindow() {
      if (!this.infoWindow?.map) { // if para evitar adicionar varios infos no mapa
        this.infoWindow = new this.google.maps.InfoWindow();
        this.infoWindow.setPosition(this.getInfoWindowPosition());
        this.infoWindow.open(this.map);
      }
      let text = (this.areaName == null ? '' : this.areaName + ': ') + this.getAreaSizeInHa() + " ha";
      this.infoWindow.setContent(text);
    },
    getInfoWindowPosition() {
      if (this.coordinates.length >= 3) {
        var bounds = new this.google.maps.LatLngBounds();
        this.coordinates.forEach(e => {
          bounds.extend(e);
        });

        return bounds.getCenter();
      }
    },
    formatCoordinatesToLatLngLiteral(coords) {
      let result = [];

      if (coords != null && coords.forEach != null) {
        coords.forEach(item => {
          result.push({
            lat: Number(item.lat ?? item.latitude),
            lng: Number(item.lng ?? item.longitude)
          });
        });
      }

      return result;
    },
    async addPolygon() {
      this.poly = await new this.google.maps.Polygon({
        paths: this.coordinates,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: "#FF0000",
        fillOpacity: 0.35,
        editable: this.readyOnly,
        map: this.map
      });

      //Add a listener for the click event
      this.google.maps.event.addListener(this.map, "click", event => {
        // Quando tiver 3 pontos não adiciona porque já tem o poligono e ele deve ser editado
        if (this.coordinates.length <= 3) {
          this.addLatLngToPoly(event);
        }
        // Quando adicionar o terceiro ponto, o poligono esta completo e exibe o tamanho da area
        if (this.coordinates.length == 3) {
          this.calculatePolygonAreaSize();
        }
      });

      this.google.maps.event.addListener(this.poly, "rightclick", event => {
        this.removeLatLngToPoly(event);
      });

      this.google.maps.event.addListener(this.poly, 'click', () => {
        this.setInfoWindow();
    });

      this.centerOnCoordinates();
    },
    centerOnCoordinates() {
      if (this.coordinates.length > 0) {
        var bounds = new this.google.maps.LatLngBounds();
        for (let i = 0; i < this.coordinates.length; i++) {
          bounds.extend(this.coordinates[i]);
        }

        this.map.setCenter(bounds.getCenter());
        this.map.fitBounds(bounds);
      }
    },
    addLatLngToPoly(clickEvent) {
      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear
      this.coordinates.push(clickEvent.latLng);
      this.poly.setPath(this.coordinates);
      this.coordinates = this.poly.getPath();

      // Update the text field to display the polyline encodings
      const encodeString = this.google.maps.geometry.encoding.encodePath(
        this.coordinates
      );

      if (encodeString) {
        document.getElementById("encoded-polyline").value = encodeString;
      }

      // Ao adicionar o primeiro ponto no mapa, inicializa os eventos do path
      if (this.poly.getPath()?.getLength() == 1) {
        this.initializePathEvents();
      }
    },
    removeLatLngToPoly(point) {
      if (point.vertex && this.poly.getPath().getLength() > 3) {
        this.poly.getPath().removeAt(point.vertex);
        this.calculatePolygonAreaSize();
      }
    },
    calculatePolygonAreaSize() {
      this.coordinates = this.poly.getPath() ?? [];
      if (this.coordinates.length < 3) {
        return 0;
      }

      this.areaSizeInMeters = this.google.maps.geometry.spherical.computeArea(
        this.coordinates
      );
      this.setPolygonFillColor();
      this.setInfoWindow();
    },
    setPolygonFillColor() {
      let fillColor = "#FF0000";
      // por exemplo, se o minimo esperado for 0, significa que nao deve validar o minimo
      if (
        (this.getAreaSizeInHa() > this.expectedMinAreaSize ||
          this.expectedMinAreaSize == 0) &&
        (this.getAreaSizeInHa() < this.expectedMaxAreaSize ||
          this.expectedMaxAreaSize == 0)
      ) {
        fillColor = "#00FF00";
      }
      this.poly.setOptions({ fillColor: fillColor });
    }
  },
  props: {
    areaName: {
      type: String,
      default: ""
    },
    coordenadas: {
      type: Array
    },
    expectedMaxAreaSize: {
      type: Number,
      default: 0
    },
    expectedMinAreaSize: {
      type: Number,
      default: 0
    },
    readyOnly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    areaName: function(newVal) {
      if (newVal) {
        this.setInfoWindow();
      }
    },
    coordenadas: function(newVal) {
      // 3 pontos para fechar um poligono
      if (newVal.length >= 3) {
        this.coordinates = this.formatCoordinatesToLatLngLiteral(this.coordenadas);
      } else {
        this.coordinates = [];
      }
      this.initializeGoogleMaps();
    },
    readyOnly: function(newVal) {
      if (this.poly) {
        this.poly.setEditable(newVal);
      }
    }
  }
};
</script>
<style>
#kml {
  width: 100%;
  height: 100%;
  align-content: center;
}
#map {
  height: 400px;
  width: 630px;
}
.pac-card {
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3);
  margin: 10px;
  padding: 0 0.5em;
  font: 400 18px Roboto, Arial, sans-serif;
  overflow: hidden;
  font-family: Roboto;
  padding: 0;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.pac-controls {
  display: inline-block;
  padding: 5px 11px;
}

.pac-controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#pac-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  margin-top: 10px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 300px;
}

#pac-input:focus {
  border-color: #4d90fe;
}
</style>
